import { CardAppImage } from 'components/cardAppImage';
import { CardAppImageProps } from 'components/cardAppImage/CardAppImage';
import { CardAppList } from 'components/cardAppList';
import { HeaderTitle } from 'components/headerTitle';
import { NextPage } from 'next';
import { WithRouterProps } from 'next/dist/client/with-router';
import { withRouter } from 'next/router';
import React from 'react';
type Props = {
  title: string;
  cardAppItems: CardAppImageProps[];
} & WithRouterProps;

const PageContent: NextPage<Props> = (props) => {
  const { title, cardAppItems } = props;

  const otherApps = cardAppItems.slice(1, cardAppItems.length);

  return (
    <React.Fragment>
      <HeaderTitle title={title} />
      {cardAppItems && cardAppItems[0] && (
        <CardAppImage
          title={cardAppItems[0].title}
          description={cardAppItems[0].description}
          image={cardAppItems[0].image}
          heroImage={cardAppItems[0].heroImage}
          urlDonwloadAppAndroid={cardAppItems[0].urlDonwloadAppAndroid}
          urlDonwloadAppAndroidLabel={cardAppItems[0].urlDonwloadAppAndroidLabel}
          urlDonwloadAppIos={cardAppItems[0].urlDonwloadAppIos}
        />
      )}
      {cardAppItems && <CardAppList cardAppItems={otherApps} />}
    </React.Fragment>
  );
};

export default withRouter(PageContent);
